import HandshqApp from '../handshq-app';

HandshqApp.EnableFormSubmit = function () {
  $('.disable-form-submit :input').change(() => {
    $(':input[type="submit"]').prop('disabled', false);
  });
};

$(() => {
  HandshqApp.EnableFormSubmit();
});
